import { Link } from 'react-router-dom'
import { CART_PATHS } from '../constants/cart'
import {
  CHECKOUT_STEP,
  CHECKOUT_STEPS,
  type CheckoutStepperProps,
} from '../constants/orders'
import { cx } from '../helpers/format'
import '../styles/checkout-page.scss'

export function CheckoutStepper({
  current,
  addressComplete = false,
  placed = false,
  onSelect,
}: CheckoutStepperProps) {
  const order = CHECKOUT_STEPS.map((step) => step.id)

  return (
    <ol className="checkout-steps">
      {CHECKOUT_STEPS.map((step, index) => {
        const currentIndex = order.indexOf(current)
        const done = index < currentIndex || (step.id === CHECKOUT_STEP.done && placed)
        const active = step.id === current
        const className = cx(
          'checkout-steps__item',
          active && 'is-active',
          done && 'is-done',
        )
        const label = (
          <>
            <span className="checkout-steps__index">{index + 1}</span>
            {step.label}
          </>
        )

        if (step.id === CHECKOUT_STEP.cart) {
          return (
            <li key={step.id}>
              <Link to={CART_PATHS.page} className={className}>
                {label}
              </Link>
            </li>
          )
        }

        const canOpen =
          step.id === CHECKOUT_STEP.address ||
          (step.id === CHECKOUT_STEP.checkout && addressComplete) ||
          (step.id === CHECKOUT_STEP.done && placed)

        return (
          <li key={step.id}>
            <button
              type="button"
              className={className}
              disabled={!canOpen || active}
              onClick={() => onSelect(step.id)}
            >
              {label}
            </button>
          </li>
        )
      })}
    </ol>
  )
}
